var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main_div" }, [
    _c(
      "div",
      { staticClass: "main_expenses" },
      _vm._l(_vm.editableExpenses, function (expense, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "row expense",
            class: { deleted: expense.is_deleted },
          },
          [
            _c(
              "div",
              { staticClass: "col-md-5 flex" },
              [
                expense.id
                  ? [
                      _c("div", { staticClass: "pl-1 store_name" }, [
                        _vm.storeId != expense.store_id
                          ? _c("p", { staticClass: "m-0" }, [
                              _vm._v(_vm._s(_vm.storeNames[expense.store_id])),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "m-0 fs-11 text-muted" }, [
                          _vm._v(_vm._s(_vm.users[expense.user_id])),
                        ]),
                        _vm._v(" "),
                        _vm.storeId == expense.store_id
                          ? _c("p", { staticClass: "m-0 fs-11 text-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.moment(
                                    expense.created_at,
                                    "DD.MM.YYYY HH:mm"
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                (!_vm.userId || _vm.userId == 0) && !expense.id
                  ? [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: expense.store_id,
                              expression: "expense.store_id",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            disabled: expense.is_deleted || expense.disabled,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                expense,
                                "store_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v("-Общие расходы-"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.$AllStores, function (store, storeId) {
                            return _c(
                              "option",
                              { domProps: { value: storeId } },
                              [_vm._v(_vm._s(store.short_title))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.allowedExpenses.some(
                  (e) => e.id === expense.type_id || !expense.type_id
                )
                  ? [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: expense.type_id,
                              expression: "expense.type_id",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            disabled: expense.is_deleted || expense.disabled,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                expense,
                                "type_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "0", disabled: "" } },
                            [_vm._v("Выберите тип расхода")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.allowedExpenses, function (type) {
                            return _c(
                              "option",
                              { domProps: { value: type.id } },
                              [_vm._v(_vm._s(type.title))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  : [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.allExpensesTypes[expense.type_id],
                            expression: "allExpensesTypes[expense.type_id]",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "Нет доступных типов расходов",
                          disabled: true,
                        },
                        domProps: {
                          value: _vm.allExpensesTypes[expense.type_id],
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.allExpensesTypes,
                              expense.type_id,
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: expense.comment,
                    expression: "expense.comment",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Комментарий",
                  disabled: expense.is_deleted || expense.disabled,
                },
                domProps: { value: expense.comment },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(expense, "comment", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group flex" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: expense.sum,
                        expression: "expense.sum",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      placeholder: "сумма",
                      disabled: expense.is_deleted || expense.disabled,
                    },
                    domProps: { value: expense.sum },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(expense, "sum", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: expense.currency_id,
                          expression: "expense.currency_id",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        disabled: expense.is_deleted || expense.disabled,
                      },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            expense,
                            "currency_id",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.currencies, function (currency, id) {
                      return _c("option", { domProps: { value: id } }, [
                        _vm._v(_vm._s(currency)),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.storeId == expense.store_id || _vm.storeId == 0
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            attrs: {
                              disabled: expense.is_deleted || expense.disabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeExpense(index)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex-jc-between" },
      [
        _c(
          "button",
          { staticClass: "btn btn-sm btn-info", on: { click: _vm.addExpense } },
          [_vm._v("Новый расход")]
        ),
        _vm._v(" "),
        _vm.getAllExpenses().length
          ? _c(
              "vue-ladda",
              {
                attrs: {
                  "button-class": "btn btn-sm btn-success",
                  "data-style": "zoom-in",
                  loading: _vm.btnLoading,
                },
                on: { click: _vm.saveExpenses },
              },
              [_vm._v("Сохранить расходы\n      ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }